export default __webpack_public_path__ + "static/media/who_are_we.8c8489e2.jpeg";